import { useState, useEffect } from "react";
import CommonServices from "../apis/common/CommonServices";
import { DropShipperTypeId } from "../utils";

function useProvideAuth() {

  // *For User
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));

  // *For DropShipper "Add To List" - needs at least one connected external store
  const [hasConnectedStore, setHasConnectedStore] = useState(false);

  // *For Login
  const userLogin = (data) => {
    localStorage.setItem('user', JSON.stringify(data))
    setUser(data)
  };

  // *For Logout
  const userLogout = async () => {
    setUser(null)
    localStorage.removeItem('user')
  };

  // *For External Store Connection Status
  const refreshConnectedStores = async () => {
    try {
      const { data } = await CommonServices.getUserExternalStores({ page: 1, limit: 30 })
      const connectedStores = Array.isArray(data)
        ? data.filter((store) => store?.is_connected !== 0)
        : []
      setHasConnectedStore(connectedStores.length > 0)
    } catch (error) {
      setHasConnectedStore(false)
    }
  };

  useEffect(() => {
    if (user?.type == DropShipperTypeId && user?.is_plan_active == 1) {
      refreshConnectedStores()
    } else {
      setHasConnectedStore(false)
    }
  }, [user]);

  return {
    user,
    userLogin,
    userLogout,
    hasConnectedStore,
    refreshConnectedStores
  };
}

export default useProvideAuth;